var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 55,
    viewBox: "0 0 175 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.08 5.83049H168.936V7.94838H173.835V47.0525H168.936V51.2928H165.08V54.2172H58.3446H9.69497V51.2928H5.50821V47.0525H1V7.94838H5.50821V5.83049H9.69497V1H165.08V5.83049Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonM);
export default __webpack_public_path__ + "static/media/ButtonM.215c2ec12df070de4e3d006ddb115171.svg";
export { ForwardRef as ReactComponent };